import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import { Bot } from 'lucide-react';

// URL del bot Telegram - normalmente verrebbe importato da un file di configurazione
const TELEGRAM_BOT_URL = 'https://t.me/escortfun_bot';

const TelegramButton: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();

  // Non mostrare il bottone nelle pagine di dettaglio dell'escort
  if (location.pathname.includes('/escort/')) {
    return null;
  }

  const handleClick = () => {
    const url = `https://img.escortfun.net/cache/contact.php?i=telegram&t=telegram&s=${encodeURIComponent(location.pathname)}`;
    try { navigator.sendBeacon(url); } catch (_) { fetch(url).catch(() => {}); }
    window.open(TELEGRAM_BOT_URL, '_blank');
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 10,
        left: 16,
        zIndex: 40,
      }}
    >
      <button
        onClick={handleClick}
        style={{
          background: '#1E88E5',
          color: '#fff',
          border: 'none',
          borderRadius: 8,
          padding: '8px 12px',
          fontSize: 14,
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          transition: 'all 0.3s ease',
          whiteSpace: 'nowrap',
        }}
        aria-label={t('common.prova_il_nostro_bot_telegram')}
      >
        <Bot size={20} />
        <span
          style={{
            overflow: 'hidden',
          }}
        >
          {t('common.prova_il_nostro_bot_telegram')}
        </span>
      </button>
    </div>
  );
};

export default TelegramButton;
